import React, { useState } from 'react';
import { useCenturionStore } from '../lib/store';
import { motion } from 'framer-motion';
import { AlertOctagon, Save, User, Clock, ShieldAlert } from 'lucide-react';
export function SettingsPanel() {
  const {
    profile,
    isLoaded,
    resetProgress,
    updateName
  } = useCenturionStore();
  const [nameInput, setNameInput] = useState(profile?.name || '');
  const [isSaved, setIsSaved] = useState(false);
  if (!isLoaded || !profile) return null;
  const handleSave = () => {
    updateName(nameInput);
    setIsSaved(true);
    setTimeout(() => setIsSaved(false), 2000);
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-2xl mx-auto pb-24" data-id="element-224">
      <header className="mb-8" data-id="element-225">
        <h1 className="text-3xl font-bold tracking-tight text-gray-100 mb-2" data-id="element-226">
          Settings
        </h1>
        <p className="text-gray-400" data-id="element-227">
          Configure your profile and manage your journey.
        </p>
      </header>

      <div className="space-y-6" data-id="element-228">
        {/* Profile Section */}
        <div className="bg-surface-300 rounded-xl p-1 border border-surface-100 shadow-xl" data-id="element-229">
          <div className="bg-surface-400 rounded-lg p-6" data-id="element-230">
            <h2 className="text-lg font-semibold text-gray-200 uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-231">
              <User size={20} className="text-centurion-500" data-id="element-232" /> Profile
            </h2>

            <div className="space-y-4" data-id="element-233">
              <div data-id="element-234">
                <label className="block text-sm font-medium text-gray-400 mb-1" data-id="element-235">
                  Recruit Name
                </label>
                <div className="flex gap-3" data-id="element-236">
                  <input type="text" value={nameInput} onChange={e => setNameInput(e.target.value)} className="flex-1 bg-surface-200 border border-surface-100 rounded-lg px-4 py-2 text-gray-200 focus:outline-none focus:border-centurion-500 focus:ring-1 focus:ring-centurion-500" placeholder="Enter your name" data-id="element-237" />
                  <button onClick={handleSave} className="bg-surface-200 hover:bg-surface-100 text-gray-200 px-4 py-2 rounded-lg border border-surface-100 transition-colors flex items-center gap-2" data-id="element-238">
                    {isSaved ? <span className="text-emerald-500" data-id="element-239">Saved</span> : <>
                        <Save size={18} data-id="element-240" /> Save
                      </>}
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4 pt-4 border-t border-surface-100" data-id="element-241">
                <div data-id="element-242">
                  <label className="block text-sm font-medium text-gray-500 mb-1 flex items-center gap-1" data-id="element-243">
                    <Clock size={14} data-id="element-244" /> Timezone
                  </label>
                  <div className="text-gray-300 font-mono-num bg-surface-200 px-3 py-2 rounded border border-surface-100 opacity-70 cursor-not-allowed" data-id="element-245">
                    {profile.timezone}
                  </div>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-246">
                    Locked to IST for demo.
                  </p>
                </div>
                <div data-id="element-247">
                  <label className="block text-sm font-medium text-gray-500 mb-1 flex items-center gap-1" data-id="element-248">
                    <ShieldAlert size={14} data-id="element-249" /> Total Resets
                  </label>
                  <div className="text-red-500 font-mono-num font-bold text-xl px-3 py-1" data-id="element-250">
                    {profile.resetCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Danger Zone */}
        <div className="bg-red-950/20 rounded-xl p-1 border border-red-900/30 shadow-xl" data-id="element-251">
          <div className="bg-surface-400/50 rounded-lg p-6" data-id="element-252">
            <h2 className="text-lg font-semibold text-red-500 uppercase tracking-wider mb-2 flex items-center gap-2" data-id="element-253">
              <AlertOctagon size={20} data-id="element-254" /> Danger Zone
            </h2>
            <p className="text-sm text-gray-400 mb-6" data-id="element-255">
              Manually reset your progress back to Day 1. This action cannot be
              undone. Your reset count will increase.
            </p>

            <button onClick={resetProgress} className="w-full sm:w-auto bg-red-900/20 hover:bg-red-900/40 text-red-500 border border-red-900/50 px-6 py-3 rounded-lg font-bold uppercase tracking-wider transition-colors flex items-center justify-center gap-2" data-id="element-256">
              <AlertOctagon size={18} data-id="element-257" />
              Initiate Manual Reset
            </button>
          </div>
        </div>
      </div>
    </motion.div>;
}